// Financiero — resumen financiero del negocio.
// Usa FinancieroDashboard (componente) que carga datos vía /api/financiero.
import FinancieroDashboard from '../components/FinancieroDashboard'

export default function Financiero() {
  return <FinancieroDashboard />
}
